<section class="bmc-powerbi">
  <div class="bmc-powerbi__header">
    <p>{{'POWERBI.DESCRIPTION' | translate}}</p>
  </div>
  <div class="bmc-powerbi__tree-main">
    <div class="bmc-powerbi__tree-panel" id="panel-tree">
      <div class="tree-container">
        <h5 class="bz-font-weight--semibold">{{ 'POWERBI.CONFIG_TITLE' | translate }}</h5>

        <div *ngIf="powerBIConfigurations">

          <div class="bmc-tree-node" *ngFor="let configuration of powerBIConfigurations" >

            <div  class="bmc-tree-node__item bmc-flex" [class.selected]="isSelected(configuration.Id)">
              <div (click)="collapseItems(isOpen(configuration.Id), configuration.Id)" style="display: inline-block;">
                <svg class="bmc-tree-node__arrow" *ngIf="configuration.ReportEnvironments.length > 0">
                  <use *ngIf="!isOpen(configuration.Id)" href="#icon-arrow-right-bold"></use>
                  <use *ngIf="isOpen(configuration.Id)" href="#icon-arrow-down-bold"></use>
                </svg>
              </div>
              <span (click)="clickItem(configuration)" class="bmc-tree-node__text bmc-display-block" >{{configuration.DisplayName}}</span>
            </div>

            <div *ngIf="isOpen(configuration.Id)">
              <div *ngFor="let reportConf of configuration.ReportEnvironments">
                <div (click)="clickItemReport(reportConf)" class="bmc-tree-node__item bmc-tree-node__margin-left" [class.selected]="isSelected(reportConf.Id)">
                  {{reportConf.DisplayName}}
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
    <div class="bmc-powerbi__tree-detail" >
      <div class="bmc-powerbi__placeholder" *ngIf="powerBIConfigurations.length > 0 && !anyItemSelected && !isLoading">
        <p class="bmc-powerbi__placeholder__text">{{'POWERBI.SELECT_COMPONENT' | translate}}</p>
      </div>
      <div *ngIf="isLoading" class="bz-env-loading">
        <bounce>{{ 'GLOBAL.LOADING_DATA' | translate }}</bounce>
      </div>
      <div *ngIf="(powerBIConfigurations.length === 0 || !powerBIConfigurations) && !isLoading">
        <div class="bmc-powerbi__image">
          <img src="assets/img/bz-not-found.png">
          <p>{{ 'POWERBI.WHITHOUT_COMPONENTS' | translate }}</p>
        </div>
      </div>
      <div *ngIf="powerBIConfigurations.length > 0 && anyItemSelected && !isLoading" class="container">
        <dv-powerbi-detail [powerBIConfiguration]="powerBIConfiguration" [reportConfiguration]="reportConfiguration" [isConexion]="isConexion" (updateTable)="updateTable()">
        </dv-powerbi-detail>
      </div>
    </div>
  </div>
</section>
